import Reveal from '../Components/Reveal';
import '../styles/About.css';
import utpLogo from '../Assets/UTP_logo.png';
import cradleLogo from '../Assets/cradle_logo.png';
import petronasLogo from '../Assets/petronas_logo.png';
import mdecLogo from '../Assets/mdec_logo.png';
import buildingImg from '../Assets/solar.jpg';
import missionImg from '../Assets/mission.jpg';
import aiMLImg from '../Assets/Futuristic AI interface in action.png';
import cloudArchImg from '../Assets/cloud computing.png';

const About = () => (
  <>
    {/* ── Section 1: Hero ────────────────────────────────────── */}
    <section className="ew-about-hero">
      <div className="ew-about-hero__inner">
        <div className="ew-about-hero__card">
          <img
            className="ew-about-hero__img"
            src={buildingImg}
            alt="Teczo EnergyWorks hero"
          />
          <div className="ew-about-hero__overlay">
            <span className="ew-about-hero__eyebrow">Empowering Energy Operations</span>
            <h1 className="ew-about-hero__heading">
              Transforming Data Chaos into <br />
              <span className="ew-about-hero__heading-muted">Strategic Intelligence</span>
            </h1>
            <p className="ew-about-hero__sub">
              Teczo EnergyWorks delivers digital, data, and engineering solutions that help
              energy organisations harness the full power of their operational data — turning
              complexity into clarity and driving measurable business outcomes.
            </p>
          </div>
        </div>
      </div>
    </section>

    {/* ── Section 2: About Introduction ─────────────────────── */}
    <section className="ew-about-intro">
      <div className="ew-about-intro__inner">

        {/* Mission — 2-col grid */}
        <Reveal>
          <div className="ew-about-intro__grid">
            {/* Left */}
            <div>
              <p className="ew-about-intro__eyebrow">Our Mission</p>
              <h2 className="ew-about-intro__heading">
                Bridging the gap between raw data and real-world energy decisions
              </h2>
            </div>
            {/* Right */}
            <div className="ew-about-intro__card">
              <img
                className="ew-about-intro__card-img"
                src={missionImg}
                alt="Data and engineering"
              />
              <p className="ew-about-intro__card-text">
                EnergyWorks is a Teczo subsidiary, founded in 2021 and headquartered in Kuala Lumpur,
                Malaysia. We are a multidisciplinary team of engineers, data scientists, and domain
                experts dedicated to modernising energy operations. From subsurface analytics to
                cloud-native platforms, our integrated approach empowers clients to make faster,
                smarter decisions backed by reliable intelligence — not guesswork.
              </p>
            </div>
          </div>
        </Reveal>

        {/* Service Pillars — 3-col grid */}
        <div className="ew-about-pillars">

          {/* Pillar 1 — Digital & Data Solutions */}
          <Reveal delay={0}>
            <div className="ew-about-pillar">
              <div className="ew-about-pillar__icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M3 3v18h18" />
                  <path d="M18 17V9" />
                  <path d="M13 17V5" />
                  <path d="M8 17v-3" />
                </svg>
              </div>
              <h4 className="ew-about-pillar__title">Digital &amp; Data Solutions</h4>
              <p className="ew-about-pillar__body">
                We design and deploy end-to-end digital platforms — from data ingestion pipelines
                to interactive dashboards — that give energy operators a single source of truth
                for all critical information.
              </p>
            </div>
          </Reveal>

          {/* Pillar 2 — Engineering & Geoscience */}
          <Reveal delay={100}>
            <div className="ew-about-pillar">
              <div className="ew-about-pillar__icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" />
                  <circle cx="12" cy="12" r="3" />
                </svg>
              </div>
              <h4 className="ew-about-pillar__title">Engineering &amp; Geoscience</h4>
              <p className="ew-about-pillar__body">
                Our technical specialists combine petroleum engineering expertise with geoscience
                workflows to deliver integrated subsurface studies, reservoir modelling, and
                production optimisation strategies.
              </p>
            </div>
          </Reveal>

          {/* Pillar 3 — Training & Development */}
          <Reveal delay={200}>
            <div className="ew-about-pillar">
              <div className="ew-about-pillar__icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 10v6M2 10l10-5 10 5-10 5z" />
                  <path d="M6 12v5c3 3 9 3 12 0v-5" />
                </svg>
              </div>
              <h4 className="ew-about-pillar__title">Training &amp; Development</h4>
              <p className="ew-about-pillar__body">
                We build capacity within client organisations through structured training
                programmes covering data literacy, digital tools, and engineering best practices
                — ensuring sustainable, long-term capability uplift.
              </p>
            </div>
          </Reveal>

        </div>
      </div>
    </section>

    {/* ── Section 3: Capabilities ────────────────────────────── */}
    <section className="ew-about-caps">
      <div className="ew-about-caps__card">
        <div className="ew-about-caps__glow" />

        <Reveal>
          <div className="ew-about-caps__header">
            <p className="ew-about-caps__eyebrow">Unified Competitive Advantage</p>
            <h2 className="ew-about-caps__heading">Where Engineering Meets Intelligence</h2>
          </div>
        </Reveal>

        <div className="ew-about-caps__grid">

          {/* Capability 1 — AI & Machine Learning */}
          <Reveal>
            <div className="ew-about-caps__item">
              <img
                className="ew-about-caps__item-img"
                src={aiMLImg}
                alt="AI and Machine Learning"
              />
              <h3 className="ew-about-caps__item-title">AI &amp; Machine Learning</h3>
              <p className="ew-about-caps__item-body">
                We embed artificial intelligence directly into energy workflows — from anomaly
                detection and predictive maintenance to production forecasting and automated
                reporting. Our ML models are trained on domain-specific datasets to deliver
                actionable insights, not just statistical noise.
              </p>
            </div>
          </Reveal>

          {/* Capability 2 — Cloud & Data Architecture */}
          <Reveal delay={200}>
            <div className="ew-about-caps__item">
              <img
                className="ew-about-caps__item-img"
                src={cloudArchImg}
                alt="Cloud and Data Architecture"
              />
              <h3 className="ew-about-caps__item-title">Cloud &amp; Data Architecture</h3>
              <p className="ew-about-caps__item-body">
                We architect scalable, secure cloud environments tailored for energy data —
                integrating disparate source systems, standardising data models, and enabling
                real-time access for field teams and executives alike. Built for reliability
                at enterprise scale.
              </p>
            </div>
          </Reveal>

        </div>
      </div>
    </section>

    {/* ── Section 4: Achievements ────────────────────────────── */}
    <section className="ew-about-ach">
      <div className="ew-about-ach__inner">

        <Reveal>
          <div className="ew-about-ach__header">
            <div>
              <p className="ew-about-ach__eyebrow">Proven Excellence</p>
              <h2 className="ew-about-ach__heading">
                Recognised impact across industry and government
              </h2>
            </div>
            <span className="ew-about-ach__badge">2021 – 2025 Milestones</span>
          </div>
        </Reveal>

        <Reveal delay={100}>
          <div className="ew-about-ach__grid">

            {/* Card 1 — UTP Vendor Award */}
            <div className="ew-about-ach__card">
              <img src={utpLogo} alt="UTP" className="ew-about-ach__card-logo" />
              <p className="ew-about-ach__card-label">UTP Vendor Award</p>
              <h4 className="ew-about-ach__card-title">Preferred Supplier Status</h4>
              <p className="ew-about-ach__card-body">
                Recognised by Universiti Teknologi PETRONAS as a preferred technology and
                engineering solutions vendor.
              </p>
            </div>

            {/* Card 2 — Cradle Funding */}
            <div className="ew-about-ach__card">
              <img src={cradleLogo} alt="Cradle" className="ew-about-ach__card-logo" />
              <p className="ew-about-ach__card-label">Cradle Funding</p>
              <h4 className="ew-about-ach__card-title">CIP SPARK Grant</h4>
              <p className="ew-about-ach__card-body">
                Awarded the Cradle CIP SPARK Grant to accelerate development of our proprietary
                digital energy platform.
              </p>
            </div>

            {/* Card 3 — Petronas Projects */}
            <div className="ew-about-ach__card">
              <img src={petronasLogo} alt="PETRONAS" className="ew-about-ach__card-logo" />
              <p className="ew-about-ach__card-label">Petronas Projects</p>
              <h4 className="ew-about-ach__card-title">~80% Efficiency Gain</h4>
              <p className="ew-about-ach__card-body">
                Delivered transformative workflow automation for PETRONAS assets, achieving
                approximately 80% efficiency improvement in reporting cycles.
              </p>
            </div>

            {/* Card 4 — MDEC Grant */}
            <div className="ew-about-ach__card">
              <img src={mdecLogo} alt="MDEC" className="ew-about-ach__card-logo" />
              <p className="ew-about-ach__card-label">MDEC Grant</p>
              <h4 className="ew-about-ach__card-title">Creative Tech Recipient</h4>
              <p className="ew-about-ach__card-body">
                Selected as a recipient of the MDEC Creative Tech grant, supporting innovation
                in energy data visualisation and digital solutions.
              </p>
            </div>

          </div>
        </Reveal>

      </div>
    </section>

    {/* ── Section 5: CTA ─────────────────────────────────────── */}
    <section className="ew-about-cta">
      <div className="ew-about-cta__card">
        <img
          className="ew-about-cta__img"
          src="https://images.unsplash.com/photo-1516937941344-00b4e0337589?auto=format&fit=crop&q=80&w=2000"
          alt="Connect with our experts"
        />
        <div className="ew-about-cta__overlay">
          <Reveal>
            <>
              <p className="ew-about-cta__eyebrow">Start the Conversation</p>
              <h2 className="ew-about-cta__heading">
                Ready to Transform Your Data into Intelligence?
              </h2>
              <p className="ew-about-cta__sub">
                Whether you're looking to modernise a legacy workflow, build a new data platform,
                or upskill your team — our experts are ready to help you move forward with confidence.
              </p>
              <button
                className="ew-about-cta__btn"
                onClick={() => window.location.href = '/#contact'}
              >
                Connect With Our Experts
              </button>
            </>
          </Reveal>
        </div>
      </div>
    </section>
  </>
);

export default About;
